import React from "react";
import { ShimmerDiv, ShimmerTitle } from "./ThemedShimmer";

const ProfilePageSkeleton = ({ className = "" }) => (
  <div
    className={`skeleton-profile-layout ${className}`.trim()}
    role="status"
    aria-busy="true"
    aria-label="Loading profile"
  >
    <span className="skeleton-screen-reader-only">Loading profile</span>
    <ShimmerDiv height={220} width="100%" rounded={8} />
    <div className="d-flex flex-column gap-3">
      <div className="d-flex align-items-end gap-3">
        <ShimmerDiv height={96} width={96} rounded={50} />
        <div className="flex-grow-1">
          <ShimmerTitle line={2} gap={8} />
        </div>
      </div>
      <ShimmerDiv height={160} width="100%" rounded={8} />
      <ShimmerDiv height={280} width="100%" rounded={8} />
    </div>
  </div>
);

export default ProfilePageSkeleton;
